module.exports = __webpack_public_path__ + "static/media/ug.b408dce8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ug.svg
// module id = 276
// module chunks = 0